@if (editPaymentInfoForm && userPaymentCardData) {
  <div class="container edit">
    <!--Account Info redirect to dashboard page-->
    <div class="acc-info-btn">
      <gds-utility-action
        [data]="{
          icon: {
            iconName: 'left-arrow-v2',
          },
          label: pageLabels?.['address.backCTA'],
          type: 'left-arrow-v2',
          disabled: false,
        }"
        (click)="bacToAccInfo()"
      ></gds-utility-action>
    </div>
    <gds-spacer classes="spacer-70"></gds-spacer>
    <!--Payment heading-->
    <gds-heading
      [data]="{
        heading: pageLabels?.['paymentInfo.editCc'],
      }"
      class="A3-W6"
    >
    </gds-heading>
    <gds-spacer classes="spacer-50"></gds-spacer>
    <gds-buttons
      [data]="{
        type: 'tertiary',
        href: '',
        label: pageLabels?.['deleteAcc.delete'],
        disabled: false,
        target: '',
      }"
      (buttonClicked)="deleteCard()"
      class="float-right"
    >
    </gds-buttons>
    <ng-container>
      <gds-spacer classes="spacer-70"></gds-spacer>
      <div [formGroup]="editPaymentInfoForm">
        <gds-heading
          [data]="{
            heading: pageLabels?.['paymentInfo.cardsAccepted'],
          }"
          class="A4-W5"
        >
        </gds-heading>
        <gds-spacer classes="spacer-50"></gds-spacer>
        <gds-credit-card-icon-row
          [selectedCreditCard]="cardType"
        ></gds-credit-card-icon-row>
        <gds-spacer classes="spacer-20"></gds-spacer>
        <gds-input
          formControlName="creditCardNumber"
          ngDefaultControl
          id="creditCardNumber"
          [data]="{
            primaryLabel: pageLabels?.['paymentInfo.cardNumber'],
            tooltip: '',
            type: 'text',
            altText: pageLabels?.['paymentInfo.cardNumber'],
            ariaText: pageLabels?.['paymentInfo.cardNumber'],
            required: true,
            disabled: true,
          }"
        >
        </gds-input>
        <gds-credit-card-form
          [data]="{
            year: {
              formField: { primaryLabel: pageLabels?.['paymentInfo.ccYear'] },
              placeholder: pageLabels?.['paymentInfo.ccYear'],
              options: yearOptions,
            },
            month: {
              formField: { primaryLabel: pageLabels?.['paymentInfo.ccMonth'] },
              placeholder: pageLabels?.['paymentInfo.ccMonth'],
              options: monthOptions,
            },
            securityCode: {
              primaryLabel: pageLabels?.['paymentInfo.ccSecurityCode'],
              tooltip: pageLabels?.['paymentInfo.securityCodeDescription'],
            },
          }"
          [errors]="{
            cardNumber: errorCardNumber,
            year: errorYear,
            month: errorMonth,
            securityCode: errorSecurityCode,
          }"
          [value]="{
            cardNumber: cardObject?.cardno,
            year: cardObject?.expiryYear,
            month: cardObject?.expiryMonth,
            securityCode: cardObject?.securitycode,
          }"
          (creditCardValueChange)="onCreditCardValueChange($event)"
          (creditCardBlurChange)="validateContinueEnabler()"
        ></gds-credit-card-form>
      </div>
      <gds-spacer classes="spacer-70"></gds-spacer>
      <app-payment-address
        [inputAddress]="userPaymentCardData"
        (emitSelectedAddress)="setAddress($event)"
      ></app-payment-address>
      <gds-spacer classes="spacer-70"></gds-spacer>
      <gds-input
        ngDefaultControl
        id="primary"
        class="checkbox-label"
        [data]="{
          primaryLabel: pageLabels?.['paymentInfo.primaryCard'],
          primaryIconTitleText: pageLabels?.['paymentInfo.primaryCard'],
          type: 'checkbox',
          altText: pageLabels?.['editCommPreferences.checkboxAltText'],
          ariaText: pageLabels?.['editCommPreferences.checkboxAltText'],
          required: true,
        }"
        (valueChange)="onPrimaryClick($event)"
        [value]="primaryVal ? 'checked' : ''"
      >
      </gds-input>
      <gds-spacer classes="spacer-70"></gds-spacer>
    </ng-container>
    <!--Address list addCTA navigate to add-address page-->
    <gds-sticky-nav-footer
      [data]="{
        button: {
          type: 'primary',
          href: '',
          label: pageLabels?.['trpAdd.confirm'],
          disabled: enableSave ? 'false' : 'true',
          target: '',
        },
      }"
      (buttonClicked)="onSubmit()"
    >
    </gds-sticky-nav-footer>
    <gds-spacer classes="spacer-70"></gds-spacer>
  </div>
}
